"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isInternal = exports.findFirstNodeSlug = exports.computeAPITree = exports.computeTagGroups = void 0;
const types_1 = require("@stoplight/types");
const lodash_1 = require("lodash");
const guards_1 = require("../../../elements-core/utils/guards");
function computeTagGroups(serviceNode, nodeType) {
    const groupsByTagId = {};
    const ungrouped = [];
    const lowerCaseServiceTags = serviceNode.tags.map(tn => tn.toLowerCase());
    const groupableNodes = serviceNode.children.filter(n => n.type === nodeType);
    for (const node of groupableNodes) {
        for (const tagName of node.tags) {
            const tagId = tagName.toLowerCase();
            if (groupsByTagId[tagId]) {
                groupsByTagId[tagId].items.push(node);
            }
            else {
                const serviceTagIndex = lowerCaseServiceTags.findIndex(tn => tn === tagId);
                const serviceTagName = serviceNode.tags[serviceTagIndex];
                groupsByTagId[tagId] = {
                    title: serviceTagName || tagName,
                    items: [node],
                };
            }
        }
        if (node.tags.length === 0) {
            ungrouped.push(node);
        }
    }
    const orderedTagGroups = Object.entries(groupsByTagId)
        .sort(([g1], [g2]) => {
        const g1LC = g1.toLowerCase();
        const g2LC = g2.toLowerCase();
        const g1Idx = lowerCaseServiceTags.findIndex(tn => tn === g1LC);
        const g2Idx = lowerCaseServiceTags.findIndex(tn => tn === g2LC);
        if (g1Idx < 0 && g2Idx < 0)
            return 0;
        if (g1Idx < 0)
            return 1;
        if (g2Idx < 0)
            return -1;
        return g1Idx - g2Idx;
    })
        .map(([, tagGroup]) => tagGroup);
    return { groups: orderedTagGroups, ungrouped };
}
exports.computeTagGroups = computeTagGroups;
const defaultComputerAPITreeConfig = {
    hideSchemas: false,
    hideInternal: false,
};
const computeAPITree = (serviceNode, config = {}) => {
    const mergedConfig = (0, lodash_1.defaults)(config, defaultComputerAPITreeConfig);
    const tree = [];
    tree.push({
        id: '/',
        slug: '/',
        title: 'Overview',
        type: 'overview',
        meta: '',
    });
    const hasOperationNodes = serviceNode.children.some(node => node.type === types_1.NodeType.HttpOperation);
    if (hasOperationNodes) {
        tree.push({
            title: 'Endpoints',
        });
        const { groups, ungrouped } = computeTagGroups(serviceNode, types_1.NodeType.HttpOperation);
        addTagGroupsToTree(groups, ungrouped, tree, types_1.NodeType.HttpOperation, mergedConfig.hideInternal);
    }
    const hasWebhookNodes = serviceNode.children.some(node => node.type === types_1.NodeType.HttpWebhook);
    if (hasWebhookNodes) {
        tree.push({
            title: 'Webhooks',
        });
        const { groups, ungrouped } = computeTagGroups(serviceNode, types_1.NodeType.HttpWebhook);
        addTagGroupsToTree(groups, ungrouped, tree, types_1.NodeType.HttpWebhook, mergedConfig.hideInternal);
    }
    let schemaNodes = serviceNode.children.filter(node => node.type === types_1.NodeType.Model);
    if (mergedConfig.hideInternal) {
        schemaNodes = schemaNodes.filter(n => !(0, exports.isInternal)(n));
    }
    if (!mergedConfig.hideSchemas && schemaNodes.length) {
        tree.push({
            title: 'Schemas',
        });
        const { groups, ungrouped } = computeTagGroups(serviceNode, types_1.NodeType.Model);
        addTagGroupsToTree(groups, ungrouped, tree, types_1.NodeType.Model, mergedConfig.hideInternal);
    }
    return tree;
};
exports.computeAPITree = computeAPITree;
const findFirstNodeSlug = (tree) => {
    for (const item of tree) {
        if ('slug' in item) {
            return item.slug;
        }
        if ('items' in item) {
            const slug = (0, exports.findFirstNodeSlug)(item.items);
            if (slug) {
                return slug;
            }
        }
    }
    return;
};
exports.findFirstNodeSlug = findFirstNodeSlug;
const isInternal = (node) => {
    const data = node.data;
    if ((0, guards_1.isHttpOperation)(data) || (0, guards_1.isHttpWebhookOperation)(data)) {
        return !!data.internal;
    }
    if ((0, guards_1.isHttpService)(data)) {
        return false;
    }
    return !!data['x-internal'];
};
exports.isInternal = isInternal;
const addTagGroupsToTree = (groups, ungrouped, tree, itemsType, hideInternal) => {
    ungrouped.forEach(node => {
        if (hideInternal && (0, exports.isInternal)(node)) {
            return;
        }
        tree.push({
            id: node.uri,
            slug: node.uri,
            title: node.name,
            type: node.type,
            meta: (0, guards_1.isHttpOperation)(node.data) || (0, guards_1.isHttpWebhookOperation)(node.data) ? node.data.method : '',
        });
    });
    groups.forEach(group => {
        const items = group.items.flatMap(node => {
            if (hideInternal && (0, exports.isInternal)(node)) {
                return [];
            }
            return {
                id: node.uri,
                slug: node.uri,
                title: node.name,
                type: node.type,
                meta: (0, guards_1.isHttpOperation)(node.data) || (0, guards_1.isHttpWebhookOperation)(node.data) ? node.data.method : '',
            };
        });
        if (items.length > 0) {
            tree.push({
                title: group.title,
                items,
                itemsType,
            });
        }
    });
};
//# sourceMappingURL=utils.js.map